module.exports = __webpack_public_path__ + "static/img/07bg.8a2b159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/share/01home/07bg.png
// module id = fQf8
// module chunks = 0